import React, { useState } from 'react';
import apis from '../../../../../../apis';
import { Modal, Button, Radio, message } from '@drip/drip-design';

function ExportData(props: { param: any; tabsIdx: number }) {
  const { param, tabsIdx } = props;
  const [isShowDlg, setIsShowDlg] = useState(false);
  const [timeType, setTimeType] = useState('day'); // 汇总/按天 total/day

  /**
   * 修改导出弹窗状态
   * @param {boolean} status
   */
  const modifyDlgStatus = (status: boolean) => {
    setIsShowDlg(status);
    if (!status) {
      setTimeType('day');
    }
  };
  const getMetaCode = (type: string) => {
    const isDay = type === 'day';
    switch (tabsIdx) {
      case 0:
        return isDay ? '75bdc731-ca59-4050-8de7-1db29e9ea2b8' : '0a7205bb-699d-478d-88b3-fdf50f1e2cf9';
      case 1:
        return isDay ? 'd5b99e1c-5f1a-4481-a011-5dcf9bb9d725' : 'ce873bf8-8d4f-4a17-8685-72eea265a3b0';
      case 2:
        return isDay ? 'e199d3b9-a936-4022-9a62-0ca68ce860c0' : 'f3c6583b-a6d1-4bbc-b03c-00a4b517df6c';
    }
  };
  /**
   * 点击导出数据按钮
   */
  const onExportData = () => {
    const downloadParam = {
      ...param,
      total: 40000,
      token: 'b7f3a383-d28f-4efe-bc7b-a824e3f986e6',
      modelId: getMetaCode(timeType),
    };
    console.log(downloadParam, '导出数据');
    apis
      .platDataOneServiceDownloadFile(downloadParam)
      .then((res) => {
        const { msg, ret } = res;
        if (ret === '0') {
          message.success('导出成功，稍后将会用鲸盘分享给您');
        } else {
          throw msg || '导出失败，请稍后重试';
        }
        modifyDlgStatus(false);
      })
      .catch((ex) => {
        modifyDlgStatus(false);
        message.error(ex);
      });
  };

  return (
    <>
      <Button type="primary" className="export-btn" onClick={() => modifyDlgStatus(true)}>
        导出数据
      </Button>
      <Modal
        title="导出数据"
        visible={isShowDlg}
        onOk={onExportData}
        onCancel={() => modifyDlgStatus(false)}
        wrapClassName="export-data-modal"
        footer={null}
        width={414}
      >
        <div className="dlg-item">
          <div className="dlg-item-title">时间粒度：</div>
          <div className="dlg-item-con">
            <Radio.Group value={timeType} onChange={(e) => setTimeType(e.target.value)}>
              <Radio value={'day'}>按天导出</Radio>
              <Radio value={'total'}>汇总导出</Radio>
            </Radio.Group>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button type="primary" style={{ marginRight: 16 }} onClick={onExportData}>
            导出
          </Button>
          <Button onClick={() => modifyDlgStatus(false)}>取消</Button>
        </div>
      </Modal>
    </>
  );
}
export default ExportData;
